import { render, staticRenderFns } from "./PdfViewArchive.vue?vue&type=template&id=d85c37d8&"
import script from "./PdfViewArchive.vue?vue&type=script&lang=js&"
export * from "./PdfViewArchive.vue?vue&type=script&lang=js&"
import style0 from "./PdfViewArchive.vue?vue&type=style&index=0&id=d85c37d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports